export default __webpack_public_path__ + "static/media/masma75127 copy_thin-1.27ec5ff6.jpg";